// Generates an array of numbers from the "from" arg to the "to" arg,
// the intervals gap determine by the "interval" arg.
// Example:Input from:10, to 20, interval :2;Output: 10,12,14,16,18,20

const generateSequence = (from: number, to: number, interval: number): Array<number> => {
    const results = [from];
    while (results[results.length - 1] < to) {
        const nextValue = results[results.length - 1] + interval;
        results.push(nextValue);
    }
    return results;
};

export const getCommonIntervals = (): Array<number> => {
    const intervals = [
        ...generateSequence(0, 100_000, 5_000),
        ...generateSequence(100_000, 500_000, 50_000),
        ...generateSequence(500_000, 1_000_000, 250_000),
        ...[1_000_000, 5_000_000, 10_000_000, 50_000_000, 100_000_000, 500_000_000],
    ];
    const distinctValues = new Set(intervals);
    const commonIntervals = Array.from(distinctValues);
    return commonIntervals;
};
